// extracted by css-extract-rspack-plugin
export default {"brandButton":"brand-button__brandButton___bx9VF"};